export default __webpack_public_path__ + "static/media/promos-detail-banner.aa27760a.jpg";